import { gql, useQuery } from "@apollo/client";
import useRequestBeforeLogin from "src/utils/hook/base/useRequestBeforeLogin";

const Q_faqList = gql`
  query faqList {
    faqList {
      edges {
        node {
          description
          id
          title
          questions {
            edges {
              node {
                title
                id
                description
                answers {
                  edges {
                    node {
                      title
                      text
                      id
                      fileUrl
                      file
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

function useGetFAQList() {
  const { requestConfig } = useRequestBeforeLogin();
  const { loading, error, data, refetch } = useQuery(
    Q_faqList,
    requestConfig({
      module: "AVC_TICKET",
    })
  );
  return { data, error, loading, refetch };
}
export default useGetFAQList;
